import { AloftPrice } from '@aloft/toolkit-shared';

import { Plan } from './types.js';

export const MONTH_PLAN: Omit<Plan, 'id'> = {
  price: AloftPrice.fromDollarLike(29),
  interval: 'month',
  features: [
    'Fast and Accurate Adjustments',
    'Cost Approach and Site Extraction',
    'Comp Recommendations',
    'Paired Sales',
    'Market Trends',
    'Cost Data and Image Analysis',
    'Public Records and MLS Data',
    'Addendum and Workfile Exports',
    'Unlimited Orders',
    'Training and Support',
    'Cancel Anytime',
  ],
};
export const YEAR_PLAN: Omit<Plan, 'id'> = {
  price: AloftPrice.fromDollarLike(290),
  interval: 'year',
  features: ['Same Great Features as Monthly Plan', 'Equivalent to 2 More Months Free'],
  badgeContent: '17% off',
  badgeColor: 'green',
};
